module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mostrar) ? _c('div', {
    staticClass: "banner-eleitoral-overlay"
  }, [_c('div', {
    staticClass: "banner-eleitoral-modal"
  }, [_c('div', {
    staticClass: "banner-eleitoral-corpo"
  }, [_c('img', {
    staticClass: "banner-eleitoral-imagem",
    attrs: {
      "src": _vm.imagem,
      "alt": "Aviso sobre o período eleitoral"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-eleitoral-rodape"
  }, [_c('button', {
    staticClass: "btn btn-primary banner-eleitoral-botao",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fechar
    }
  }, [_vm._v("\n        Fechar\n      ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24a712a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/BannerPeriodoEleitoral.vue
// module id = 1884
// module chunks = 1